export default __webpack_public_path__ + "static/Deutsche_Telekom-Logo-3f50c78742990e132cc08a9ccc6416a0.svg";